<template>
  <main-content>
      <div class="p-2">
          <ul class="nav nav-pills bg-white" role="tablist">
              <li class="nav-item" v-if="$can('read-wallet-list', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'wallet-list' ? 'active' : '']"
                     @click="setTab('wallet-list')"
                     href="#"
                     id="wallet-list-tab"
                     role="tab"
                  >
                      <span v-text="$t('wallets.label.wallet_list')"></span>
                  </a>
              </li>
              <li class="nav-item" v-if="$can('read-settlement-and-charge-list', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'transaction-list' ? 'active' : '']"
                     @click="setTab('transaction-list')"
                     href="#"
                     id="transaction-list-tab"
                     role="tab"
                  >
                      <span>
                          <span v-text="$t('wallets.label.transaction_list')"></span>&nbsp;
                          <span v-text="unknown_charges_count" class="bg-danger rounded-circle px-2 text-white"></span>
                      </span>
                  </a>
              </li>
              <li class="nav-item" v-if="$can('read-settlement-and-charge-list', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'settlement-list' ? 'active' : '']"
                     @click="setTab('settlement-list')"
                     href="#"
                     id="settlement-list-tab"
                     role="tab"
                  >
                      <span>
                          <span v-text="$t('wallets.label.settlement_list')"></span>&nbsp;
                          <span v-text="pending_settlements_count" class="bg-primary rounded-circle px-2 text-white"></span>&nbsp;
                          <span v-text="unknown_settlements_count" class="bg-danger rounded-circle px-2 text-white"></span>
                      </span>
                  </a>
              </li>
              <li class="nav-item" v-if="$can('read-general-settings', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'wallet-setting' ? 'active' : '']"
                     @click="setTab('wallet-setting')"
                     href="#"
                     id="wallet-setting-tab"
                     role="tab"
                     v-text="$t('wallets.label.wallet_setting')">
                  </a>
              </li>
              <li class="nav-item" v-if="$can('change-general-settings', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'wallet-switch' ? 'active' : '']"
                     @click="setTab('wallet-switch')"
                     href="#"
                     id="wallet-switch-tab"
                     role="tab"
                     v-text="$t('label.wallet_switching_settings')">
                  </a>
              </li>

              <li class="nav-item" v-if="$can('read-bank-statements', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'statement-report' ? 'active' : '']"
                     @click="setTab('statement-report')"
                     href="#"
                     id="statement-report-tab"
                     role="tab"
                     v-text="$t('wallets.label.statement-report')">
                  </a>
              </li>

              <li class="nav-item" v-if="$can('manage-banks', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'token-manage' ? 'active' : '']"
                     @click="setTab('token-manage')"
                     href="#"
                     id="token-manage-tab"
                     role="tab"
                     v-text="$t('label.bank_management')">
                  </a>
              </li>
            <li class="nav-item" v-if="$can('manage-banks', 'wallet') &&  $can('read-account-balance-reconciliation','wallet')" role="presentation">
              <a :class="['nav-link', active_tab === 'balances' ? 'active' : '']"
                 @click="setTab('balances')"
                 href="#"
                 id="balance-tab"
                 role="tab"
                 v-text="$t('label.balances')">
              </a>
            </li>
            <li class="nav-item" v-if="$can('manage-banks', 'wallet') && $can('manage-interbank-transfer', 'wallet')" role="presentation">
              <a :class="['nav-link', active_tab === 'transfer' ? 'active' : '']"
                 @click="setTab('transfer')"
                 href="#"
                 id="transfer-tab"
                 role="tab"
                 v-text="$t('label.transfer_between_banks')">
              </a>
            </li>
            <li class="nav-item" v-if="$can('read', 'wallet')" role="presentation">
              <a :class="['nav-link', active_tab === 'errors' ? 'active' : '']"
                 @click="setTab('errors')"
                 href="#"
                 id="errors-tab"
                 role="tab"
                 v-text="$t('label.wallet_errors')">
              </a>
            </li>
              <li class="nav-item" v-if="$can('manage-settlement', 'wallet')" role="presentation">
                  <a :class="['nav-link', active_tab === 'history' ? 'active' : '']"
                     @click="setTab('history')"
                     href="#"
                     id="history-tab"
                     role="tab"
                     v-text="$t('label.wallet_history')">
                  </a>
              </li>
            <li class="nav-item" v-if="$can('read', 'wallet') && $can('read-wages', 'transaction') && fetch_starshop" role="presentation">
              <a :class="['nav-link', active_tab === 'profit' ? 'active' : '']"
                 @click="setTab('profit')"
                 href="#"
                 id="profit-tab"
                 role="tab"
                 v-text="$t('label.company_daily_profit')">
              </a>
            </li>
            <li class="nav-item" v-if="$can('manage-settlement-limit-settings', 'wallet') && !fetch_starshop" role="presentation">
              <a :class="['nav-link', active_tab === 'blacklist_pf' ? 'active' : '']"
                 @click="setTab('blacklist_pf')"
                 href="#"
                 id="blacklist-pf-tab"
                 role="tab"
                 v-text="$t('label.wallet_settlement_blacklist.wallet_settlement_account_name_blacklist')">
              </a>
            </li>
            <li class="nav-item" v-if="$can('manage-settlement-limit-settings', 'wallet') && fetch_starshop" role="presentation">
              <a :class="['nav-link', active_tab === 'blacklist_starshop' ? 'active' : '']"
                 @click="setTab('blacklist_starshop')"
                 href="#"
                 id="blacklist-starshop-tab"
                 role="tab"
                 v-text="$t('label.wallet_settlement_blacklist.wallet_settlement_account_name_blacklist')">
              </a>
            </li>
            <li class="nav-item" v-if="($can('manage-settlement-limit-settings', 'wallet')) && fetch_starshop" role="presentation">
                <a :class="['nav-link', active_tab === 'shareholder-settings' ? 'active' : '']"
                   @click="setTab('shareholder-settings')"
                   href="#"
                   id="shareholder-settings-tab"
                   role="tab"
                   v-text="$t('label.shareholder_settings')">
                </a>
            </li>
              <li class="nav-item" v-if="$can('read-statistics', 'wallet')" role="presentation">
              <a :class="['nav-link', active_tab === 'open-banking' ? 'active' : '']"
                 @click="setTab('open-banking')"
                 href="#"
                 id="open-banking-tab"
                 role="tab"
                 v-text="$t('label.wallet_open_banking')">
              </a>
            </li>
          </ul>
          <div class="tab-content">
              <div class="tab-pane fade show active"
                   id="wallet-list"
                   role="tabpanel"
                   v-if="active_tab === 'wallet-list'">
                  <wallet-list :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></wallet-list>
              </div>
              <div class="tab-pane fade show active"
                   id="transaction-list"
                   role="tabpanel"
                   v-if="active_tab === 'transaction-list'">
                  <transaction-list :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></transaction-list>
              </div>
              <div class="tab-pane fade show active"
                   id="settlement-list"
                   role="tabpanel"
                   v-if="active_tab === 'settlement-list'">
                  <settlement-list :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></settlement-list>
              </div>
              <div class="tab-pane fade show active"
                   id="wallet-setting"
                   role="tabpanel"
                   v-if="active_tab === 'wallet-setting'">
                  <wallet-setting :key="container" :fetch_starshop="fetch_starshop"></wallet-setting>
              </div>
              <div class="tab-pane fade show active"
                   id="wallet-switch"
                   role="tabpanel"
                   v-if="active_tab === 'wallet-switch'">
                  <wallet-switching-setting  :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></wallet-switching-setting>
              </div>

              <div class="tab-pane fade show active"
                   id="statement-report"
                   role="tabpanel"
                   v-if="active_tab === 'statement-report'">
                  <statement-report :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></statement-report>
              </div>
              <div class="tab-pane fade show active"
                   id="token-manage"
                   role="tabpanel"
                   v-if="active_tab === 'token-manage'">
                  <bank-token :key="container" :fetch_starshop="fetch_starshop"></bank-token>
              </div>
            <div class="tab-pane fade show active"
                 id="balances"
                 role="tabpanel"
                 v-if="active_tab === 'balances'">
              <balances :key="container" :fetch_starshop="fetch_starshop"></balances>
            </div>
            <div class="tab-pane fade show active"
                 id="balances"
                 role="tabpanel"
                 v-if="active_tab === 'transfer'">
              <transfer :key="container" :fetch_starshop="fetch_starshop"></transfer>
            </div>
              <div class="tab-pane fade show active"
                 id="wallet_errors"
                 role="tabpanel"
                 v-if="active_tab === 'errors'">
                <wallet_errors :key="container" :api_base_path="api_base_path"></wallet_errors>
              </div>
              <div class="tab-pane fade show active"
                 id="wallet_history"
                 role="tabpanel"
                 v-if="active_tab === 'history'">
                <wallet-history :key="container" :api_base_path="api_base_path"></wallet-history>
              </div>
              <div class="tab-pane fade show active"
                   id="profit"
                   role="tabpanel"
                   v-if="active_tab === 'profit' && fetch_starshop">
                <profit :key="container"></profit>
              </div>
              <div class="tab-pane fade show active"
                   id="blacklist_pf"
                   role="tabpanel"
                   v-if="active_tab === 'blacklist_pf'">
                <blacklist :key="container"></blacklist>
              </div>
              <div class="tab-pane fade show active"
                   id="blacklist_starshop"
                   role="tabpanel"
                   v-if="active_tab === 'blacklist_starshop' && fetch_starshop">
                  <blacklist :key="container"></blacklist>
              </div>
              <div class="tab-pane fade show active"
                   id="shareholder-settings"
                   role="tabpanel"
                   v-if="active_tab === 'shareholder-settings' && fetch_starshop">
                  <ShareholderSetting :key="container"></ShareholderSetting>
              </div>
              <div class="tab-pane fade show active"
                   id="open-banking"
                   role="tabpanel"
                   v-if="active_tab === 'open-banking'">
                  <open-banking-requests :api_base_path="api_base_path" :key="container"
                                         :fetch_starshop="fetch_starshop"></open-banking-requests>
              </div>
          </div>
      </div>
      <div class="mt-4 mb-2 bg-white border rounded p-2">
          <div v-text="$t('label.help')"></div>
          <div class="my-2">
              <span class="bg-danger rounded-circle px-2 text-white">&nbsp;</span>&nbsp;
              <span v-text="$t('message.unknown_transactions_which_need_admin_action')"></span>
          </div>
          <div class="my-2">
              <span class="bg-primary rounded-circle px-2 text-white">&nbsp;</span>&nbsp;
              <span v-text="$t('message.pending_settlement_requests')"></span>
          </div>
      </div>
  </main-content>
</template>

<script>
  import mainContent from "@/components/main-content.vue";
  import WalletList from "./components/wallet-list.vue";
  import TransactionList from "./components/transaction-list.vue";
  import SettlementList from "./components/settlement-list.vue";
  import OpenBankingRequests from "./components/open-banking-requests.vue";
  import WalletSetting from "./components/wallet-setting.vue";
  import StatementReport from "./components/statement-report";
  import PayaReport from "./components/paya-report";
  import {ApiUrl, walletService} from "@/common/api.service";
  import BankToken from "@/views/wallets/AyandeWallets/Admin/components/bank-token.vue";
  import Balances from "@/views/wallets/AyandeWallets/Admin/components/balances.vue";
  import Transfer from "@/views/wallets/AyandeWallets/Admin/components/Transfer.vue";
  import Wallet_errors from "@/views/wallets/AyandeWallets/Admin/components/wallet-errors.vue";
  import WalletHistory from "@/views/wallets/AyandeWallets/Admin/components/wallet-history.vue";
  import Profit from "@/views/wallets/AyandeWallets/Admin/components/profit.vue";
  import WalletSwitchingSetting from "@/views/wallets/AyandeWallets/Admin/components/wallet-switching-setting.vue";
  import WalletSettlementAccountBlacklist from "../components/WalletSettlementAccountBlacklist.vue";
  import blacklist from "./components/blacklist.vue";
  import ShareholderSetting from "@/views/wallets/AyandeWallets/ShareholderSetting.vue";

  export default {
      components: {
        ShareholderSetting,
          WalletHistory,
          Profit,
          Wallet_errors,
          Transfer,
        Balances,
          BankToken,
          mainContent,
          WalletList,
          TransactionList,
          SettlementList,
          WalletSetting,
          StatementReport,
          PayaReport,
          WalletSwitchingSetting,
          WalletSettlementAccountBlacklist,
          blacklist,
          OpenBankingRequests,
      },
      data() {
          return {
              active_tab: "wallet-list",
              unknown_charges_count: 0,
              unknown_settlements_count: 0,
              pending_settlements_count: 0,
              inactive_wallets_count: 0,
              container: 0,
          }
      },
      methods: {
          getUnknownTransactionCounts() {
              let params = {
                  wallet_prefix: 'A',
              };

              const unknownTransactionCount = this.fetch_starshop
                  ? walletService.getStarShopUnknownTransactionCounts
                  : walletService.getUnknownTransactionCounts;

              unknownTransactionCount(params).then(res => {
                  this.unknown_charges_count      = res.data.data.unknown_charges_count;
                  this.unknown_settlements_count  = res.data.data.unknown_settlements_count;
                  this.pending_settlements_count  = res.data.data.pending_settlements_count;
                  this.inactive_wallets_count     = res.data.data.inactive_wallets_count;
              });
          },
          setTab(selected_tab) {
              this.active_tab = selected_tab;
          },
      },
      computed: {
          fetch_starshop() {
              return this.$route.params.slug === 'starshop';
          },
          api_base_path() {
              if (this.fetch_starshop) {
                  return  ApiUrl.starshopPath('')
              } else {
                  return  ApiUrl.path('');
              }
          }
      },
      watch: {
            $route() {
                this.container +=1;
                if (this.$can('read-statistics', 'wallet')) {
                    this.getUnknownTransactionCounts();
                }
            }
      },
      mounted() {
          if (this.$can('read-statistics', 'wallet')) {
              this.getUnknownTransactionCounts();
          }
      }
  }
</script>
